import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Phone, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Password from '../Common/Password';
import { FeatureFlag } from 'react-launch-darkly';

// Components
import Map from '../Map/Map';

const UserSettings = observer(class UserSettings extends React.Component {
  constructor() {
    super();
    this.handleTabs = this.handleTabs.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.confirmPassword = this.confirmPassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.renderLocation = this.renderLocation.bind(this);
    this.setLocation = this.setLocation.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;
    const { profile } = SessionStore;

    SessionStore.getTimezones();
    SessionStore.getCurrencies();

    this.state = {
      settings: {
        proctorTypes: []
      },
      homePhone: profile.homePhone,
      mobilePhone: profile.mobilePhone,
      currencyCode: '',
      timeZoneSid: '',
      activeTab: 1,
      preferredEmail: ''
    }

    this.getUserSettings();

    // Select tab if present in url
    let urlTab = 1;

    switch (getURLSegment(this, 2)) {
      case 'password':
        urlTab = 2;
        break;

      default:
        urlTab = 1;
    }

    this.setState({
      activeTab: urlTab
    })

  }

  componentDidUpdate(prevProps) {
    // This if statement makes sure settings-main isn't focused when making changes to the settings page
    if(prevProps !== this.props){
      const main = document.getElementById('settings-main');
      if (main && this.props.enrollment) {
        setTimeout(()=>main.focus(),250)
      }
    }
  }

  getUserSettings() {
    this.props.store.SettingsStore.getUserSettings(this, getURLSegment(this, 1));
  }

  handleTabs(index) {
    this.setState({
      activeTab: index + 1,
    });

    // Update url
    let newPath = '/settings/general';

    switch (index + 1) {
      case 2:
        newPath = '/settings/password';
        break;

      default:
        newPath = '/settings/general';
    }

    this.props.routing.push(newPath);
  }

  handleInput(e, name) {
    let data = null;
    let value = null;

    if(name === 'homePhone' || name === 'mobilePhone') {
      value = e;

      this.setState({
        [name]: value
      })
    } else {
      value = e.target.value;

      this.setState({
        [name]: value
      })
    }

    // Make sure boolean values are boolean
    if(value === 'true') {
      value = true;
    }
    if(value === 'false') {
      value = false;
    }

    data = {
      [name]: value
    };

    this.props.store.SettingsStore.updateUserData(data);
  }

  handleSubmit() {
    const { translation } = this.props;
    this.props.store.SettingsStore.updateUserSettings(this.complete, translation.location_required, this.props.enrollment);
  }

  confirmPassword(e) {
    e.preventDefault();

    // Make sure confirm password matches
    let newPass = document.querySelector('#password-new');
    let confirm = document.querySelector('#password-confirm');

    if(newPass.value !== this.confirmPass.value) {
      confirm.setCustomValidity('Passwords do not match.');
    } else {
      confirm.setCustomValidity('');
    }

    checkValidity(e, this.handlePasswordSubmit);
  }

  handlePasswordSubmit() {
    let newPass = document.querySelector('#password-new');

    const data = {
      currentPassword: this.currentPass.value,
      newPassword: newPass.value,
      confirmNewPassword: this.confirmPass.value
    }

    this.props.store.SettingsStore.updatePassword(data, this.complete);

    // Reset the password form
    this.currentPass.value = '';
    newPass.value = '';
    this.confirmPass.value = '';

    // Make sure the now empty input fields aren't flagged as invalid
    const form = document.querySelector('form.submitted');

    if(form) {
      form.className = form.className.replace('submitted', '');
    }
  }

  complete() {
    if(this.props.enrollment) {
      let prod = false;

      if(process.env.REACT_APP_ENVIRONMENT === 'production') {
        prod = true;
      }

      if(prod) {
        this.props.routing.push({
          pathname: '/'
        });
      } else {
        this.props.setStep(null, 6);

        if(this.props.smarterID) {
          this.props.setDisplayStep(4);
        } else {
          this.props.setDisplayStep(3);
        }
      }
    } else {
      this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
    }
  }

  setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, preventRender) {
    const data = {
      latitude: lat,
      longitude: lng,
      address: document.querySelector('#map-search').value
    }

    this.props.store.SettingsStore.updateUserData(data);
  }

  renderLocation() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { profile, userData } = SessionStore;

    // Default map options
    const center = {
      lat: profile.latitude || -33.8688,
      lng: profile.longitude || 151.2195
    }

    let locationSet = false;
    let zoom = 13;
    let dropPin = false;

    if(profile.latitude && profile.longitude) {
      locationSet = true;
      zoom = 17;
      dropPin = true;
    }

    if(userData.role.toLowerCase() === 'learner') {
      return (
        <fieldset className="form-section">
          <p className="note">
            {translation.enrollment_location}
          </p>

          <ul className="fields">
            <li>
              <label
                className="lbl-required"
                htmlFor="map-search"
              >
                {translation.location.label}
              </label>

              <Map
                locationSet={locationSet}
                setLocation={this.setLocation}
                store={this.props.store}
                center={center}
                zoom={zoom}
                dropPin={dropPin}
                default={profile.address}
              />
            </li>
          </ul>
        </fieldset>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;
    const { profile } = SessionStore;

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    if(
      SessionStore.loadingCalls.indexOf('GetUserSettings') < 0 &&
      SessionStore.loadingCalls.indexOf('TimeZones') < 0 &&
      SessionStore.loadingCalls.indexOf('Currencies') < 0
    ) {
      return (
        <div className="wrap block-form">
          <div className="panel">
            <div className="panel__header">
              <h3 className="panel__title" id="settings-main" tabIndex="0"><legend>{translation.heading}</legend></h3>
            </div>

            <Tabs
              className="panel__body"
              onSelect={this.handleTabs}
              forceRenderTabPanel={true}
              selectedIndex={this.state.activeTab - 1}
            >
              <TabList className="tabs-enabled">
                <Tab>{translation.general}</Tab>

                {SessionStore.userData.role.toLowerCase() === 'administrator' &&
                  <Tab>{translation.password}</Tab>
                }
              </TabList>

              <TabPanel>
                <form onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
                  {this.props.enrollment &&
                    <p className="note">
                      {translation.enrollment_instructions}
                    </p>
                  }

                  <h4 className="meta">{translation.general}</h4>

                  <fieldset className="form-section">
                    <ul className="fields">
                      <li className="field--half">
                        <label className="lbl-required" htmlFor="profile-fname">{translation.name.first}</label>
                        <span className="faux-input">{profile.firstName}</span>
                      </li>
                      <li className="field--half">
                        <label className="lbl-required" htmlFor="profile-lname">{translation.name.last}</label>
                        <span className="faux-input">{profile.lastName}</span>
                      </li>
                      <li>
                        <label
                          className="lbl-required"
                          htmlFor="profile-email"
                        >
                          {translation.email.label}
                        </label>

                        <span className="field-instruction">
                          {translation.email.instruction}
                        </span>

                        <input
                          type="email"
                          ref={(input) => this.preferredEmail = input}
                          defaultValue={profile.preferredEmail}
                          required
                          aria-required="true"
                          onChange={(e) => this.handleInput(e, 'preferredEmail')}
                          placeholder={translation.email.helper}
                        />
                      </li>
                      <li>
                        <label className="lbl-optional" htmlFor="profile-phone">{translation.home_phone.label}</label>
                        <Phone
                          id="profile-phone"
                          nativeExpanded={true}
                          flagsPath="./static/img/flags/"
                          country={parsePhoneNumber(profile.homePhone).country || 'US'}
                          value={profile.homePhone}
                          onChange={(e) => {this.handleInput(e, 'homePhone')}}
                          aria-invalid={!isValidPhoneNumber(this.state.homePhone)}
                          placeholder={translation.home_phone.label}
                        />
                      </li>
                      <li>
                        <label className="lbl-optional" htmlFor="profile-mobile">{translation.mobile.label}</label>
                        <Phone
                          id="profile-mobile"
                          nativeExpanded={true}
                          flagsPath="./static/img/flags/"
                          country={parsePhoneNumber(profile.mobilePhone).country || 'US'}
                          value={profile.mobilePhone}
                          onChange={(e) => {this.handleInput(e, 'mobilePhone')}}
                          aria-invalid={!isValidPhoneNumber(this.state.mobilePhone)}
                          placeholder={translation.mobile.label}
                        />
                      </li>
                      <li>
                        <label className="lbl-required" htmlFor="settings-timezone">{translation.timezone.label}</label>
                        <label className="select" htmlFor="settings-timezone">
                          <select id="settings-timezone"
                            ref={(input) => { this.defaultTimezone = input }}
                            value={this.state.timeZoneSid}
                            required
                            aria-required="true"
                            onChange={(e) => {this.handleInput(e, 'timeZoneSid')}}
                          >
                            <option value="">{translation.timezone.helper}</option>
                            {SessionStore.timezoneList.map(
                              (key, i) =>
                              <option key={i} value={key.sid}>{key.name}</option>
                            )}
                          </select>
                        </label>
                      </li>
                      <li>
                        <label className="lbl-required" htmlFor="profile-currency">{translation.currency.label}</label>
                        <label className="select" htmlFor="profile-currency">
                          <select
                            id="profile-currency"
                            ref={(input) => {this.currency = input}}
                            value={this.state.currencyCode}
                            required
                            aria-required="true"
                            onChange={(e) => {this.handleInput(e, 'currencyCode')}}
                          >
                            <option value="">{translation.currency.helper}</option>
                            {SessionStore.currencyList.map(
                              (key, i) =>
                              <option key={i} value={key.code}>{key.name}</option>
                            )}
                          </select>
                        </label>
                      </li>
                    </ul>
                  </fieldset>

                  <FeatureFlag
                    flagKey="automated-only"
                    renderFeatureCallback={() => {
                      // If automated-only, we don’t need the student’s location
                      // so we will just set it to the GR office
                      SettingsStore.updateUserData({
                        latitude: 42.923900,
                        longitude: -85.585870,
                        address: '3351 Claystone St SE, Grand Rapids, MI 49546'
                      });

                      return null;
                    }}
                    renderDefaultCallback={this.renderLocation}
                  />

                  <div className="panel__actions actions">
                    <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
                  </div>
                </form>
              </TabPanel>

              {SessionStore.userData.role.toLowerCase() === 'administrator' &&
                <TabPanel>
                  <form onSubmit={(e) => this.confirmPassword(e)} noValidate>
                    <h4 className="meta">{translation.password}</h4>

                    <fieldset className="form-section">
                      <ul className="fields">
                        <li>
                          <label className="lbl-required" htmlFor="password-current">
                            {translation.password_settings.current}
                          </label>

                          <input
                            id="password-current"
                            type="password"
                            ref={(input) => {this.currentPass = input}}
                            required
                            aria-required="true"
                          />
                        </li>
                        <li>
                          <label className="lbl-required" htmlFor="password-new">
                            {translation.password_settings.new}
                          </label>

                          <Password
                            id="password-new"
                            parent={this}
                            name="password"
                            {...this.props}
                          />
                        </li>
                        <li>
                          <label className="lbl-required" htmlFor="password-confirm">
                            {translation.password_settings.confirm}
                          </label>

                          <input
                            id="password-confirm"
                            type="password"
                            ref={(input) => {this.confirmPass = input}}
                            required
                            aria-required="true"
                          />
                        </li>
                      </ul>
                    </fieldset>

                    <div className="panel__actions actions">
                      <button className="actions__btn actions__btn--primary" type="submit">{translation.save}</button>
                    </div>
                  </form>
                </TabPanel>
              }
            </Tabs>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('UserSettings')(UserSettings);



// WEBPACK FOOTER //
// ./src/app/components/Settings/UserSettings.js